function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M501.8,270.1c-0.6-13.9-14.2-25-40.5-33c-20.4-6.1-46.3-9.8-74.3-10.4V120c-0.1-1.8-0.6-3.5-1.5-5 c-2.8-12.1-16.3-21.9-40.2-29.1c-22.5-6.8-51.9-10.5-82.8-10.5c-30.8,0-59.9,3.7-82,10.5c-18.1,5.6-39.8,16-39.8,33.9 c0,1.1,0.1,2.2,0.3,3.3l1.1,45.6c-65-12.4-127.7,30.3-140,95.2C0.7,271.3,0,278.7,0,286.2c0,66,53.7,119.7,119.7,119.7 c27.5,0,54.1-9.4,75.4-26.8c18.7,4.4,40.7,6.8,64,7c5.1,27.7,65.1,40.4,121,40.4c30.8,0,59.9-3.8,82-10.7 c18.1-5.6,39.8-16.1,39.8-34V272C501.9,271.4,501.9,270.7,501.8,270.1z M366.1,175.3c0,1.3-4.8,8.2-26.5,14.8 c-20.3,6.1-48.4,9.7-77,9.7c-24.7,0-48.9-2.6-68.1-7.5c-0.3-0.1-0.5-0.1-0.8-0.2c-9.5-7.5-20-13.5-31.3-17.7l-0.7-28.2 c6.9,3.5,14.1,6.3,21.6,8.3c21.7,6.3,49.8,9.7,79.3,9.7c30.8,0,60.3-3.7,82.8-10.5c7.5-2.2,14.8-5.1,21.7-8.7v26.2 C366,172.6,366.1,173.9,366.1,175.3z M186.5,105.2c20.2-6.2,47.2-9.7,76-9.7c28.6,0,56.7,3.5,77,9.7c21.7,6.6,26.5,13.4,26.5,14.7 c0,1.4-4.9,8.3-26.6,14.8c-20.3,6.1-48.3,9.6-76.9,9.6c-27.6,0-53.8-3.2-73.7-9c-21.5-6.2-27.5-13-28-15.2c0-0.2-0.1-0.2-0.1-0.2 C160.8,118,165.4,111.6,186.5,105.2z M186.8,360C146.1,397,83,394.1,46,353.4s-34.1-103.8,6.6-140.8 c18.3-16.7,42.3-25.9,67.1-25.9c10,0,19.9,1.5,29.5,4.4c34.7,10.8,60.8,39.6,68.2,75.1c1.3,6.6,2,13.4,2,20.1 C219.5,314.4,207.6,341.1,186.8,360z M212.2,362.2c8.1-9.9,14.6-21,19.2-32.9c8.5,0.7,17.3,1.2,26.5,1.3v1.8l0.6,33.9 C243,366.1,227.5,364.7,212.2,362.2z M238.9,274.4c5.8,0.4,11.9,0.6,18.1,0.7l0.6,35.4c-7-0.1-13.9-0.4-20.5-0.9 c1.5-7.7,2.3-15.6,2.3-23.4C239.4,282.3,239.2,278.4,238.9,274.4z M263.5,255.2c-0.3,0-0.7,0-1,0c-9.6,0-18.9-0.4-27.5-1 c-3.8-13.4-9.8-26-17.9-37.2c15,1.9,30.1,2.9,45.3,2.9c30.9,0,60.4-3.7,82.9-10.5c7.5-2.2,14.7-5.1,21.6-8.6V227 C324,228.2,279.9,237.2,263.5,255.2z M276.7,271.1c0-0.1,0-0.2,0.1-0.4c0.9-2.7,8-9.3,28.7-15.1c19.4-5.5,44.7-8.5,71.3-8.5h1.7 c28.6,0,56.6,3.3,77,9.5c21.3,6.4,26.3,13,26.4,14.5v0.1c-0.1,1.5-5.1,8.4-27.3,15c-20.5,6.1-47.5,9.4-76,9.4 c-27.6,0-53.8-3.2-73.7-8.9c-21.5-6.2-27.4-13.1-28-15.2C276.7,271.1,276.7,271.1,276.7,271.1z M456.3,396.8 c-20.2,6.3-47.3,9.8-76.1,9.8c-28.9,0-55.9-3.4-75.9-9.5c-21.1-6.5-25.5-13.2-25.5-14.7c0-0.1,0-0.1,0-0.2l-0.5-29 c8,3.9,16.3,6.9,24.9,9.1c21,5.5,47.7,8.6,75.1,8.6c30.9,0,60.2-3.7,82.6-10.5c7.3-2.2,14.3-5.1,21-8.5v30h0.1 C482,383.3,477.4,390.2,456.3,396.8z M482.1,323.2H482c0,1-0.6,2.2-0.6,3.3c0,1.4-4.7,8.2-26.3,14.8c-20.5,6.2-47.8,9.6-76.7,9.6 c-55.4,0-92.7-12.5-100.5-22.2l-0.1-8.4l-0.4-23c7,3.5,14.3,6.3,21.8,8.4c21.7,6.3,49.8,9.7,79.3,9.7c30.4,0,59.4-3.6,81.7-10.2 c7.6-2.1,14.9-5,21.9-8.6V323.2z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M156.1,300.4c-4.6-16.3-19.5-27.5-36.4-27.5c-9.8,0-17.8-7.9-17.8-17.7c0.1-9.9,8-17.8,17.8-17.8s17.8,8,17.8,17.8 c0,5.5,4.5,10,10,10s10-4.5,10-10c0-16.9-11.2-31.8-27.5-36.4v-4.5c0-5.5-4.5-10-10-10s-10,4.5-10,10v4.3 c-20.1,5.4-32.1,26.1-26.7,46.2c4.4,16.5,19.3,28,36.4,28c9.8,0,17.8,7.9,17.8,17.7s-7.9,17.8-17.7,17.8s-17.8-7.9-17.8-17.7 c0-5.5-4.5-10-10-10s-10,4.5-10,10c0.1,17.1,11.5,32,28,36.5v8.7c0,5.5,4.5,10,10,10s10-4.5,10-10V347 C150.1,341.3,161.8,320.5,156.1,300.4z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var SvgDollar = function SvgDollar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 501.9 501.9",
    style: {
      enableBackground: "new 0 0 501.9 501.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDollar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dollar.3b446743.svg";
export { ForwardRef as ReactComponent };